import { render, staticRenderFns } from "./SSVerifyEmailView.vue?vue&type=template&id=1fa6b8dd&scoped=true&"
import script from "./SSVerifyEmailView.vue?vue&type=script&lang=js&"
export * from "./SSVerifyEmailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa6b8dd",
  null
  
)

export default component.exports